'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refSet = refSet;
exports.refUpdate = refUpdate;
exports.refRemove = refRemove;
exports.default = watchActions;

var _reduxSaga = require('redux-saga');

var _routing = require('../actions/routing');

var _projectsActions = require('../actions/projectsActions');

var _firebase = require('../utils/firebase');

var _firebase2 = _interopRequireDefault(_firebase);

var _actionTypes = require('../constants/actionTypes');

var _projectActions = require('./projectActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [updateProjectName, addProject, shareProject, projectUpdateNode, projectUpdateNodes, projectRemoveNode, projectRemoveEdge, projectDetachNode, projectAddNode, projectAddEdge, appendNewNode, appendRightNode, appendRightConnectedNode, appendBottomConnectedNode, projectSetPermission, watchDeleteProject, watchActions].map(regeneratorRuntime.mark);
/* injects from baggage-loader */

function refSet(path, value) {
  (0, _firebase2.default)(path).set(value);
}

function refUpdate(path, value) {
  (0, _firebase2.default)(path).update(value);
}

function refRemove(path) {
  (0, _firebase2.default)(path).remove();
}

function updateProjectName() {
  var _ref, projectId, value;

  return regeneratorRuntime.wrap(function updateProjectName$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 10;
            break;
          }

          _context.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.UPDATE_PROJECT_NAME);

        case 3:
          _ref = _context.sent;
          projectId = _ref.projectId;
          value = _ref.value;
          _context.next = 8;
          return (0, _reduxSaga.call)(refSet, 'projects/' + projectId + '/name', value);

        case 8:
          _context.next = 0;
          break;

        case 10:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}

function addProject() {
  var _ref2, userId, project, transition, _projectId;

  return regeneratorRuntime.wrap(function addProject$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!true) {
            _context2.next = 15;
            break;
          }

          _context2.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.ADD_PROJECT);

        case 3:
          _ref2 = _context2.sent;
          userId = _ref2.userId;
          project = _ref2.project;
          transition = _ref2.transition;
          _context2.next = 9;
          return (0, _reduxSaga.call)(_projectActions.initAddProject, userId, project);

        case 9:
          _projectId = _context2.sent;

          if (!transition) {
            _context2.next = 13;
            break;
          }

          _context2.next = 13;
          return (0, _reduxSaga.put)((0, _routing.previewProject)(userId, _projectId));

        case 13:
          _context2.next = 0;
          break;

        case 15:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this);
}

function shareProject() {
  var _ref3, userName, _userId, _project, _projectId2, projectTitle, base64Data, projectImageUrl, facebookShareLink;

  return regeneratorRuntime.wrap(function shareProject$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (!true) {
            _context3.next = 22;
            break;
          }

          _context3.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.SHARE_PROJECT);

        case 3:
          _ref3 = _context3.sent;
          userName = _ref3.userName;
          _userId = _ref3.userId;
          _project = _ref3.project;
          _projectId2 = _project.id;
          projectTitle = _project.title;
          _context3.next = 11;
          return (0, _reduxSaga.call)(_projectActions.initGenerateProjectImage, { userName: userName, userId: _userId, project: _project });

        case 11:
          base64Data = _context3.sent;
          _context3.next = 14;
          return (0, _reduxSaga.call)(_projectActions.initUploadProjectImage, { projectId: _projectId2, base64Data: base64Data });

        case 14:
          projectImageUrl = _context3.sent;
          facebookShareLink = (0, _projectActions.getFacebookShareLink)({ projectId: _projectId2, userId: _userId, projectImageUrl: projectImageUrl, projectTitle: projectTitle });
          _context3.next = 18;
          return (0, _reduxSaga.put)((0, _projectsActions.shareProjectGotFBLink)(facebookShareLink));

        case 18:
          _context3.next = 20;
          return (0, _reduxSaga.put)((0, _projectsActions.shareProjectSuccess)());

        case 20:
          _context3.next = 0;
          break;

        case 22:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this);
}

function projectUpdateNode() {
  var _ref4, _projectId3, nodeId, data;

  return regeneratorRuntime.wrap(function projectUpdateNode$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (!true) {
            _context4.next = 11;
            break;
          }

          _context4.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.UPDATE_NODE);

        case 3:
          _ref4 = _context4.sent;
          _projectId3 = _ref4.projectId;
          nodeId = _ref4.nodeId;
          data = _ref4.data;
          _context4.next = 9;
          return (0, _reduxSaga.call)(refUpdate, 'projects/' + _projectId3 + '/nodesData/' + nodeId, data);

        case 9:
          _context4.next = 0;
          break;

        case 11:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked[3], this);
}

function projectUpdateNodes() {
  var _ref5, _projectId4, nodesIds, nodesData;

  return regeneratorRuntime.wrap(function projectUpdateNodes$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (!true) {
            _context5.next = 11;
            break;
          }

          _context5.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.UPDATE_NODES);

        case 3:
          _ref5 = _context5.sent;
          _projectId4 = _ref5.projectId;
          nodesIds = _ref5.nodesIds;
          nodesData = _ref5.nodesData;
          _context5.next = 9;
          return (0, _reduxSaga.call)(_projectActions.initUpdateNodes, _projectId4, nodesIds, nodesData);

        case 9:
          _context5.next = 0;
          break;

        case 11:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked[4], this);
}

function projectRemoveNode() {
  var _ref6, _projectId5, _nodeId;

  return regeneratorRuntime.wrap(function projectRemoveNode$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          if (!true) {
            _context6.next = 10;
            break;
          }

          _context6.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.REMOVE_NODE);

        case 3:
          _ref6 = _context6.sent;
          _projectId5 = _ref6.projectId;
          _nodeId = _ref6.nodeId;
          _context6.next = 8;
          return (0, _reduxSaga.call)(_projectActions.initRemoveNode, _projectId5, _nodeId);

        case 8:
          _context6.next = 0;
          break;

        case 10:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked[5], this);
}

function projectRemoveEdge() {
  var _ref7, _projectId6, edgeId;

  return regeneratorRuntime.wrap(function projectRemoveEdge$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          if (!true) {
            _context7.next = 10;
            break;
          }

          _context7.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.REMOVE_EDGE);

        case 3:
          _ref7 = _context7.sent;
          _projectId6 = _ref7.projectId;
          edgeId = _ref7.edgeId;
          _context7.next = 8;
          return (0, _reduxSaga.call)(_projectActions.initRemoveEdge, _projectId6, edgeId);

        case 8:
          _context7.next = 0;
          break;

        case 10:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked[6], this);
}

function projectDetachNode() {
  var _ref8, _projectId7, _nodeId2;

  return regeneratorRuntime.wrap(function projectDetachNode$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          if (!true) {
            _context8.next = 10;
            break;
          }

          _context8.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.DETACH_NODE);

        case 3:
          _ref8 = _context8.sent;
          _projectId7 = _ref8.projectId;
          _nodeId2 = _ref8.nodeId;
          _context8.next = 8;
          return (0, _reduxSaga.call)(_projectActions.initDetachNode, _projectId7, _nodeId2);

        case 8:
          _context8.next = 0;
          break;

        case 10:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked[7], this);
}

function projectAddNode() {
  var _ref9, _projectId8, nodeData;

  return regeneratorRuntime.wrap(function projectAddNode$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          if (!true) {
            _context9.next = 10;
            break;
          }

          _context9.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.ADD_NODE);

        case 3:
          _ref9 = _context9.sent;
          _projectId8 = _ref9.projectId;
          nodeData = _ref9.nodeData;
          _context9.next = 8;
          return (0, _reduxSaga.call)(_projectActions.initAddNode, _projectId8, nodeData);

        case 8:
          _context9.next = 0;
          break;

        case 10:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked[8], this);
}

function projectAddEdge() {
  var _ref10, _projectId9, from, to;

  return regeneratorRuntime.wrap(function projectAddEdge$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          if (!true) {
            _context10.next = 11;
            break;
          }

          _context10.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.ADD_EDGE);

        case 3:
          _ref10 = _context10.sent;
          _projectId9 = _ref10.projectId;
          from = _ref10.from;
          to = _ref10.to;
          _context10.next = 9;
          return (0, _reduxSaga.call)(_projectActions.initAddEdge, _projectId9, from, to);

        case 9:
          _context10.next = 0;
          break;

        case 11:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked[9], this);
}

function appendNewNode() {
  var _ref11, _projectId10, newNodeData, id;

  return regeneratorRuntime.wrap(function appendNewNode$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          if (!true) {
            _context11.next = 11;
            break;
          }

          _context11.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.APPEND_NEW_NODE);

        case 3:
          _ref11 = _context11.sent;
          _projectId10 = _ref11.projectId;
          newNodeData = _ref11.newNodeData;
          id = _ref11.id;
          _context11.next = 9;
          return (0, _reduxSaga.call)(_projectActions.initAppendNewNode, _projectId10, { newNodeData: newNodeData, id: id });

        case 9:
          _context11.next = 0;
          break;

        case 11:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked[10], this);
}

function appendRightNode() {
  var _ref12, _projectId11, _newNodeData, _id;

  return regeneratorRuntime.wrap(function appendRightNode$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          if (!true) {
            _context12.next = 11;
            break;
          }

          _context12.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.APPEND_RIGHT_NODE);

        case 3:
          _ref12 = _context12.sent;
          _projectId11 = _ref12.projectId;
          _newNodeData = _ref12.newNodeData;
          _id = _ref12.id;
          _context12.next = 9;
          return (0, _reduxSaga.call)(_projectActions.initAppendRightNode, _projectId11, { newNodeData: _newNodeData, id: _id });

        case 9:
          _context12.next = 0;
          break;

        case 11:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked[11], this);
}

function appendRightConnectedNode() {
  var _ref13, _projectId12, _newNodeData2, _id2;

  return regeneratorRuntime.wrap(function appendRightConnectedNode$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          if (!true) {
            _context13.next = 11;
            break;
          }

          _context13.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.APPEND_RIGHT_CONNECTED_NODE);

        case 3:
          _ref13 = _context13.sent;
          _projectId12 = _ref13.projectId;
          _newNodeData2 = _ref13.newNodeData;
          _id2 = _ref13.id;
          _context13.next = 9;
          return (0, _reduxSaga.call)(_projectActions.initAppendRightConnectedNode, _projectId12, { newNodeData: _newNodeData2, id: _id2 });

        case 9:
          _context13.next = 0;
          break;

        case 11:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked[12], this);
}

function appendBottomConnectedNode() {
  var _ref14, _projectId13, _newNodeData3, _id3;

  return regeneratorRuntime.wrap(function appendBottomConnectedNode$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          if (!true) {
            _context14.next = 11;
            break;
          }

          _context14.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.APPEND_BOTTOM_CONNECTED_NODE);

        case 3:
          _ref14 = _context14.sent;
          _projectId13 = _ref14.projectId;
          _newNodeData3 = _ref14.newNodeData;
          _id3 = _ref14.id;
          _context14.next = 9;
          return (0, _reduxSaga.call)(_projectActions.initAppendBottomConnectedNode, _projectId13, { newNodeData: _newNodeData3, id: _id3 });

        case 9:
          _context14.next = 0;
          break;

        case 11:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked[13], this);
}

function projectSetPermission() {
  var _ref15, _userId2, _projectId14, isPublic, isListed;

  return regeneratorRuntime.wrap(function projectSetPermission$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          if (!true) {
            _context15.next = 12;
            break;
          }

          _context15.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.SET_PERMISSION);

        case 3:
          _ref15 = _context15.sent;
          _userId2 = _ref15.userId;
          _projectId14 = _ref15.projectId;
          isPublic = _ref15.isPublic;
          isListed = _ref15.isListed;
          _context15.next = 10;
          return (0, _reduxSaga.fork)(_projectActions.initProjectSetPermission, _userId2, _projectId14, isPublic, isListed);

        case 10:
          _context15.next = 0;
          break;

        case 12:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked[14], this);
}

function watchDeleteProject() {
  var _ref16, _project2;

  return regeneratorRuntime.wrap(function watchDeleteProject$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          if (!true) {
            _context16.next = 9;
            break;
          }

          _context16.next = 3;
          return (0, _reduxSaga.take)(_actionTypes.DELETE_PROJECT);

        case 3:
          _ref16 = _context16.sent;
          _project2 = _ref16.project;
          _context16.next = 7;
          return (0, _reduxSaga.fork)(_projectActions.initDeleteProject, _project2);

        case 7:
          _context16.next = 0;
          break;

        case 9:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked[15], this);
}

function watchActions() {
  return regeneratorRuntime.wrap(function watchActions$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _reduxSaga.fork)(addProject);

        case 2:
          _context17.next = 4;
          return (0, _reduxSaga.fork)(updateProjectName);

        case 4:
          _context17.next = 6;
          return (0, _reduxSaga.fork)(projectUpdateNode);

        case 6:
          _context17.next = 8;
          return (0, _reduxSaga.fork)(projectUpdateNodes);

        case 8:
          _context17.next = 10;
          return (0, _reduxSaga.fork)(shareProject);

        case 10:
          _context17.next = 12;
          return (0, _reduxSaga.fork)(projectRemoveEdge);

        case 12:
          _context17.next = 14;
          return (0, _reduxSaga.fork)(projectDetachNode);

        case 14:
          _context17.next = 16;
          return (0, _reduxSaga.fork)(projectRemoveNode);

        case 16:
          _context17.next = 18;
          return (0, _reduxSaga.fork)(projectAddNode);

        case 18:
          _context17.next = 20;
          return (0, _reduxSaga.fork)(projectAddEdge);

        case 20:
          _context17.next = 22;
          return (0, _reduxSaga.fork)(appendNewNode);

        case 22:
          _context17.next = 24;
          return (0, _reduxSaga.fork)(appendRightNode);

        case 24:
          _context17.next = 26;
          return (0, _reduxSaga.fork)(appendRightConnectedNode);

        case 26:
          _context17.next = 28;
          return (0, _reduxSaga.fork)(appendBottomConnectedNode);

        case 28:
          _context17.next = 30;
          return (0, _reduxSaga.fork)(projectSetPermission);

        case 30:
          _context17.next = 32;
          return (0, _reduxSaga.fork)(watchDeleteProject);

        case 32:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked[16], this);
}


//////////////////
// WEBPACK FOOTER
// ./app/sagas/actions.js
// module id = 229
// module chunks = 1